export default __webpack_public_path__ + "9349870f713dd8f7f349d2f4c04c98cf.png";